module.exports = __webpack_public_path__ + "b846f8f80a960389baa9c0ceaf3492a5.png";